<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <PermissionForm
                                    @loadData="loadEzData"
                                    @changeData="changePermissionList"
                                    :selectedData="selected_permission"
                                    ref="permissionForm"
                                ></PermissionForm>
                            </div>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <ButtonAdd
                                            label="Tambah"
                                            @click="tambah($event)"
                                            class="mr-1"
                                        />
                                        <ButtonDelete
                                            :disabled="
                                                selected_permission.length == 0
                                            "
                                            label="Hapus"
                                            @click="hapus($event)"
                                            class="mr-1"
                                        />
                                        <ButtonEdit
                                            :disabled="
                                                selected_permission.length != 1
                                            "
                                            label="Edit"
                                            @click="edit($event)"
                                            class="mr-1"
                                        />
                                    </template>

                                    <template #end> </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedPermission"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Toolbar from "primevue/toolbar";
import ButtonAdd from "@/Components/ButtonAdd";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit";
import InputText from "primevue/inputtext";
import PermissionForm from "@/Pages/Permission/Partials/PermissionForm";
import EzDataTable from "@/Components/EzDataTable";
import ButtonReset from "@/Components/ButtonReset";

import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        Toolbar,
        InputText,
        AppLayout,
        BreadCrumb,
        ButtonAdd,
        ButtonDelete,
        ButtonEdit,
        PermissionForm,
        EzDataTable,
        ButtonReset,
    },
    data() {
        return {
            ezdtConfig: {
                dtHeader: "Permission",
                globalFilter: ["name", "guard_name"],
                defineCols: [
                    {
                        field: "name",
                        header: "Name",
                        style: "min-width: 15rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "title",
                        header: "Title",
                        style: "min-width: 25rem",
                        col_type: "text",
                    },
                    {
                        field: "guard_name",
                        header: "Guard Name",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "roles",
                        header: "Role",
                        style: "min-width: 15rem",
                        col_type: "text",
                        col_display: "badge_array",
                        col_badge_array_attr: "name",
                        isSortAble: false,
                        isFilterAble: false,
                    },
                    {
                        field: "created_at",
                        header: "Created At",
                        style: "min-width: 15rem",
                        col_type: "date",
                    },
                ],
                dtSourceApiRoute: {
                    list: "permission.data",
                    drop: "permission.bulkdelete",
                },
            },
            selected_permission: [],
        };
    },
    methods: {
        changePermissionList: function (data) {
            this.$refs.ezdt.changeDataSourceList(data);
            this.$refs.ezdt.loadData();
        },
        loadEzData: function () {
            this.$refs.ezdt.loadData();
        },
        getSelectedPermission: function (data) {
            this.selected_permission = data;
        },
        tambah: function (event) {
            this.selected_permission = [];
            this.$refs.ezdt.resetSelection();
        },
        edit: function (event) {
            this.$refs.permissionForm.populateEdit(this.selected_permission[0]);
        },
        hapus: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete (" +
                    this.selected_permission.length +
                    ") selected record ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    let ids = [];
                    this.selected_permission.forEach(function (item, index) {
                        ids.push(item.id);
                    });

                    this.$refs.ezdt.dropData(ids);
                },
                reject: () => {
                    //
                },
            });
        },
        resetPassword: function (event) {
            let self = this;
            self.$confirm.require({
                target: event.currentTarget,
                message: "Yakin akan melakukan reset ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    axios
                        .post(route("permission.resetpassword"), {
                            id: self.selected_permission[0].id,
                        })
                        .then((res) => {
                            if (res.data.stts == Pesan.OK.STTS) {
                                self.$refs.lo.showToastOk();
                            }
                        })
                        .catch(function (error) {
                            //
                        })
                        .then(function () {
                            //
                        });
                },
                reject: () => {
                    //callback to execute when permission rejects the action
                },
            });
        },
    },
});
</script>
